<template>
  <div class="tax-accordance" >
    
    <TaxComparison />
    <br>
    <custom-p-checkbox
					:value='needAsteriskFact'
					@input='onNeedAsteriskFact'
					:disabled='!actLpoIsDraft'
					label='Включить в Приложение 1 строку Ф*'
		/>
    <br>
    <custom-p-checkbox
					:value='needAllSpAnnex1'
					@input='onNeedAllSpAnnex1'
					:disabled='!actLpoIsDraft'
					label='Разбивка по породам в Приложении 1'
		/>
    <br>
    <div class="check-accord-block">
      <!-- <custom-p-checkbox v-model='valueTaxNotAccords' label='Фактическая таксационная характеристика лесного насаждения не соответствует ТО'/> -->

      <div class="check-accord-block__title">
        Фактическая таксационная характеристика лесного насаждения:
      </div>
      <div class="tax-accordance" :class="{ 'not-match': ((taxAccords === null) || (!isMatchTaxAccords))}">
        <label class="tax-accordance__option">
          <input
            type="radio"
            :value="true"
            name="tax-accordance-choice"
            v-model="taxAccords"
            :disabled="!actLpoIsDraft || (!taxAccordCheck && ['5','7'].includes(lpo.inspection_type_id))"
          />
          <span>соответствует ТО</span>
        </label>

        <label class="tax-accordance__option">
          <input
            type="radio"
            :value="false"
            name="tax-accordance-choice"
            v-model="taxAccords"
            :disabled="!actLpoIsDraft || (taxAccordCheck && ['5','7'].includes(this.lpo.inspection_type_id))"
          />
          <span>не соответствует ТО</span>
        </label>
      </div>
    </div>

    <div class="tax-accordance__species-priority">
      <SpeciesPriority v-if="!['5','7'].includes(lpo.inspection_type_id)"/>
    </div>

    <div class="grid select-value-block" v-if="taxAccords === false">
      <div >
        <span class="select-title">Причина несоответствия</span>
        <custom-p-select
          v-model="values['disparity_reason'].value"
          :options="info_disparity_reasons"
          :disabled="!actLpoIsDraft"
        />
      </div>

      <div >
        <span class="select-title">Бонитет</span>
        <custom-p-select
          v-model="values['bonitet'].value"
          :options="info_bonitet"
          :disabled="!actLpoIsDraft"
        />
      </div>

      <div >
        <span class="select-title">Тип леса</span>
        <custom-p-input
          v-model="values['forest_type'].value"
          :options="info_bonitet"
          :disabled="!actLpoIsDraft"
        />
      </div>

      <div >
        <span class="select-title">Подрост</span>
        <custom-p-input
          v-model="values['underwood'].value"
          :options="info_bonitet"
          :disabled="!actLpoIsDraft"
        />
      </div>
    </div>
    

    <div
      class="values-btn-row not-match-block"
      v-if="
        !isMatchTaxAccords || (taxAccords === false && notMatchingValues.length)
      "
    >
      <div>
        <button @click="cancel">Отмена</button>
        <button @click="save">Сохранить</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

import TaxComparison from "./CurrentLpo__taxAccordanceComparison";
import SpeciesPriority from "./speciesPriority/SpeciesPriority";

export default {
  name: "InspectionTaxAccordance",
  components: {
    TaxComparison,
    SpeciesPriority,
  },
  data() {
    return {
      valueTaxNotAccords: false,

      taxAccords: null,

      values: {
        disparity_reason: {
          field: "disparity_reason_id",
          inputType: "select",
          value: null,
          catalog: "info_disparity_reasons",
        },

        bonitet: {
          field: "bonitet_id_new",
          inputType: "select",
          value: null,
          catalog: "info_bonitet",
        },

        forest_type: {
          field: "forest_type_new",
          inputType: "input",
          value: null,
        },

        underwood: {
          field: "underwood_new",
          inputType: "input",
          value: null,
        },
      },

      catalogsAreLoading: false,
    };
  },
  computed: {
    taxAccordCheck() {
      if (['5','7'].includes(this.lpo.inspection_type_id)) {
        return !this.speciesTaxNotAccord
        //return this.speciesTaxNotAccord === this.taxAccords
      } else {
        return !this.visualTaxNotAccord
      }
    },
    actLpoIsDraft() {
      return this.$store.getters["lpoData/actLpoIsDraft"];
    },

    lpoTaxAccordance() {
      switch (this.lpo.tax_accordance) {
        case "t":
          return true;
        case "f":
          return false;
        default:
          return null;
      }

      // return this.lpo.tax_accordance === 't' ? true : false;
    },

    isMatchTaxAccords() {
      // return this.valueTaxNotAccords === !this.lpoTaxAccordance;
      return this.taxAccords === this.lpoTaxAccordance;
    },

    notMatchingValues() {
      const result = [];

      for (const value_name in this.values) {
        if (!this.isMatch(this.values[value_name])) {
          result.push(value_name);
        }
      }

      return result;
    },
    needAsteriskFact() {
				return this.lpo.need_asterisk_fact === 't' ? true : false;
		},
    needAllSpAnnex1() {
        return this.lpo.need_all_sp_annex1 === 't' ? true : false;
    },
    ...mapState({
      lpo: (state) => state.selectedLpo.lpo,
      info_disparity_reasons: (state) =>
        state.catalogs["info_disparity_reasons"],
      info_bonitet: (state) => state.catalogs["info_bonitet"],
    }),
    ...mapState("selectedLpo", {
      taxComparison: (state) => state.taxComparison,
    }),
    ...mapGetters('selectedLpo', [
				'speciesTaxNotAccord',
        'visualTaxNotAccord'
			]),
  },
  methods: {
    onNeedAsteriskFact(checked) {
				this.toggleNeedAsteriskFact(checked).then(res => {
					return this.updateLpo(this.lpo.lpo_id);
				});
		},
    onNeedAllSpAnnex1(checked) {
				this.toggleNeedAllSpAnnex1(checked).then(res => {
					return this.updateLpo(this.lpo.lpo_id);
				});
		},
    save() {
      const valueList = [];
      // if (!this.valueTaxNotAccords) {
      if (this.taxAccords) {
        const temp = {
          field: "tax_accordance",
          value: true,
        };
        valueList.push(temp);

        for (const value_name in this.values) {
          const value = this.values[value_name];

          const temp = {
            field: value.field,
            value: null,
          };
          valueList.push(temp);
        }
      } else {
        const temp = {
          field: "tax_accordance",
          value: false,
        };
        valueList.push(temp);

        for (const value_name of this.notMatchingValues) {
          const inputTypeIsSelect =
            this.values[value_name].inputType === "select";

          const temp = {
            field: this.values[value_name].field,
            value: inputTypeIsSelect
              ? (this.values[value_name].value ? this.values[value_name].value.id: null)
              : (this.values[value_name].value ? this.values[value_name].value: null)
          };
          valueList.push(temp);
        }
        console.log(valueList);
      }
      this.saveLpoValue(valueList)
        .then((res) => {
          return this.updateLpo();
        })
        .then((res) => {
          this.resetValues();
        });
    },

    cancel() {
      this.resetValues();
    },

    resetValues() {
      this.taxAccords = this.lpoTaxAccordance;
      // this.valueTaxNotAccords = !this.lpoTaxAccordance;

      for (let value_name in this.values) {
        const value = this.values[value_name];

        if (value.inputType === "checkbox") {
          value.value = this.lpo[value.field] === "t";
        } else if (value.inputType === "select") {
          const temp = this[value.catalog].find((item) => {
            return item.id === this.lpo[value.field];
          });
          value.value = temp ? temp : null;
        } else if (value.inputType === "input") {
          value.value = this.lpo[value.field];
        }
      }
    },

    isMatch(value) {
      if (this.catalogsAreLoading) {
        return true;
      }

      // if (!this.valueTaxNotAccords) {
      // 	return true;
      // }

      if (value.inputType === "input") {
        return value.value === this.lpo[value.field];
      } else if (value.inputType === "select") {
        if (!value.value) {
          return this.lpo[value.field] === null;
        } else {
          return value.value.id === this.lpo[value.field];
        }
      }

      return false;
    },

    ...mapActions("selectedLpo", ['toggleNeedAsteriskFact', 'toggleNeedAllSpAnnex1', "saveLpoValue", "updateLpo"]),
  },
  created() {
    const catalogs = ["info_disparity_reasons", "info_bonitet"];
    this.catalogsAreLoading = true;
    this.$store.dispatch("loadCatalogs", catalogs).then((res) => {
      this.catalogsAreLoading = false;
      this.resetValues();
      if (['5','7'].includes(this.lpo.inspection_type_id) && this.taxAccordCheck != this.taxAccords) {
        this.taxAccords = this.taxAccordCheck
      }
    });
  },
  watch: {
    taxAccordCheck(newE, oldE) {
      if (['5','7'].includes(this.lpo.inspection_type_id)) {
        if(newE !== null) {
          //console.log(this.taxAccords)
          this.taxAccords = newE
        }
      }
    }
  },
};
</script>

<style scoped src="@/style/grid.css"></style>
<style scoped src="@/style/input.css"></style>
<style scoped src="@/style/button.css"></style>

<style scoped>
.tax-accordance {
  margin-top: 4px;
  padding: 4px;
}
.tax-accordance__option {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 0.2rem !important;
}

.check-accord-block__title {
  font-weight: bold;
}
</style>

<style scoped>
.not-match {
  border: 2px solid red;
}

.select-value-block {
  margin-top: 34px;
}

.select-title {
  font-weight: bold;
  display: inline-block;
  margin-bottom: 6px;
}

.check-accord-block {
  margin-top: 1rem;
  margin-bottom: 16px;
}
</style>
